<script lang="ts">
    import { Gridbehavior, Horizontalatalltimes } from "../../../utils/Constant/Constant";
</script>

<tbody>
    <tr>
        <th class="text-nowrap" scope="row">{Gridbehavior}</th>
        <td>{Horizontalatalltimes}</td>
        <td colspan="4">Collapsed to start, horizontal above breakpoints</td>
    </tr>
    <tr>
        <th class="text-nowrap" scope="row">Max container width</th>
        <td>None (auto)</td>
        <td class="digits">540px</td>
        <td class="digits">720px</td>
        <td class="digits">960px</td>
        <td class="digits">1140px</td>
    </tr>
    <tr>
        <th class="text-nowrap" scope="row">Class prefix</th>
        <td><code>.col-</code></td>
        <td><code>.col-sm-</code></td>
        <td><code>.col-md-</code></td>
        <td><code>.col-lg-</code></td>
        <td><code>.col-xl-</code></td>
    </tr>
    <tr>
        <th class="text-nowrap" scope="row"># of columns</th>
        <td colspan="5">12</td>
    </tr>
    <tr>
        <th class="text-nowrap" scope="row">Gutter width</th>
        <td colspan="5">30px (15px on each side of a column)</td>
    </tr>
    <tr>
        <th class="text-nowrap" scope="row">Nestable</th>
        <td colspan="5">Yes</td>
    </tr>
    <tr>
        <th class="text-nowrap" scope="row">Offsets</th>
        <td colspan="5">Yes</td>
    </tr>
    <tr>
        <th class="text-nowrap" scope="row">Column ordering</th>
        <td colspan="5">Yes</td>
    </tr>
</tbody>
